import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2CraftsIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 20.864 21.23",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21.23),
    children: [/*#__PURE__*/jsx("path", {
      d: "m.583 12.838a.252.252 0 0 0 .354.354l12.147-9.387a1.576 1.576 0 0 0 .413-2.336c-.72-.831-2.354-.094-2.88.588z"
    }), /*#__PURE__*/jsx("path", {
      d: "m12.331 2.482-.714.714"
    }), /*#__PURE__*/jsx("path", {
      d: "m15.811 5.437c-1.054.08-1.76.029-2.247-.528a2.463 2.463 0 0 1 -.459-.988"
    }), /*#__PURE__*/jsx("path", {
      d: "m11.456 2.486-.72-.77a3.042 3.042 0 0 0 -2.206-.969 3.042 3.042 0 0 0 -2.218.942 3.043 3.043 0 0 1 -4.153.235"
    }), /*#__PURE__*/jsx("path", {
      d: "m11.429 17.525.6-2.176 2.1-.825.601-2.175 2.101-.824.601-2.176 1.763-.45.6-2.176-1.124-1.013-10.993 8.438z"
    }), /*#__PURE__*/jsx("path", {
      d: "m5.427 16.647 2.251-2.5 3.75 3.377-2.25 2.5a.673.673 0 0 1 -.95.05l-2.75-2.477a.673.673 0 0 1 -.05-.95z"
    }), /*#__PURE__*/jsx("path", {
      d: "m7.453 16.66 1.5 1.35"
    })]
  });
};

export { PM2CraftsIcon };
//# sourceMappingURL=crafts.js.map
